export default __webpack_public_path__ + "static/media/transparent_trophy_cover.c38c865d.png";